import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';
import {DashboardComponent} from './dashboard.component';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'dashboard',
    component: DashboardComponent,
    future: true,
    data: {
      pageTitle: 'states.dashboard.pageTitle',
      breadcrumbTitle: 'states.dashboard.breadcrumbTitle',
      breadcrumbRoot: true,
      scopes: ['dashboard:read']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class DashboardRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/dashboard/dashboard.routes.ts